module.exports = __webpack_public_path__ + "static/media/kaiser-permanente-logo.80b62761.svg";